// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;


import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Components/Home/Home";
import AboutUs from "./Components/AboutUs/About";
import Project from "./Components/Project/Project";
import Contact from "./Components/Contact/Contact";
import BuildingAcoustics from "./Components/Services/BuildingAcoustics";
import AV from "./Components/Services/AV";
import IT from "./Components/Services/IT";
import SRA from "./Components/Services/SRA";
import Security from "./Components/Services/Security";
import ProjectManagement from "./Components/Services/ProjectManagement";
import AdminLogin from "./Components/Admin/AdminLogin";
import AdminDashboard from "./Components/Admin/AdminDashboarb";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
import Career from "./Components/Career/Career";
import ServicePage from "./Components/ServicePage/ServicePage";
import QualityPolicy from "./Components/QualityPolicy/QualityPolicy";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/project" element={<Project />} />
        <Route path="/contact" element={<Contact />} />
         <Route path="/careers" element={<Career />} />
        {/* <Route path="/acoustics" element={<BuildingAcoustics />} />
        <Route path="/av" element={<AV />} />
 
        <Route path="/ibms" element={<IT />} />
        <Route path="/security-risk-assessment" element={<SRA />} />
        <Route path="/security" element={<Security />} />
        <Route path="/project-management" element={<ProjectManagement />} /> */}
       <Route path="/service/*" element={<ServicePage />} />
       <Route path="/quality-policy" element={<QualityPolicy/>}/>

         <Route path="/admin-login" element={<AdminLogin />} />

         <Route path="/admin-dashboard" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
